import { gql } from '@apollo/client';

export const GET_COMPREHENSIVE_ANALYTICS = gql`
  query GetComprehensiveAnalytics($communityId: ID!, $fromDate: String!, $toDate: String!) {
    community(id: $communityId) {
      id
      comprehensiveAnalytics(fromDate: $fromDate, toDate: $toDate) {
        lastAuditDate
        confidence
        totalReports
        auditSessions
        itemsAudited
        performanceMetrics {
          avgAccuracy
          avgPrecision
          avgRecall
          avgF1Score
        }
        labelAnalysis {
          exactMatches {
            count
            percentage
          }
          missingLabels {
            count
            percentage
          }
          additionalLabels {
            count
            percentage
          }
          bothMissingAndAdditional {
            count
            percentage
          }
        }
        decisionAnalysis {
          conflicts {
            count
            percentage
          }
          skipped {
            count
            percentage
          }
        }
      }
    }
  }
`;
